import moment from "moment-business-days";

interface YearsOptions {
    id: number,
    value: number
}

interface MonthsOptions {
    id: number,
    value: number
}

const now = moment();

let years: YearsOptions[] = [];
let months: MonthsOptions[] = [];
let id = 0;

for (let i = 2015; i <= now.year(); i++) {
    id++;
    years.push({ id: id, value: i });
}

const getMonth = (month: number) => {
    switch(month){
        case 1: return 'ENE.'
        case 2: return 'FEB.'
        case 3: return 'MAR.'
        case 4: return 'ABR.'
        case 5: return 'MAY.'
        case 6: return 'JUN.'
        case 7: return 'JUL.'
        case 8: return 'AGO.'
        case 9: return 'SEP.'
        case 10: return 'OCT.'
        case 11: return 'NOV.'
        case 12: return 'DIC.'
    }
}

for (let i = 1; i <= 12; i++) {
    id++;
    months.push({ id: id, value: i });
}

function range(start: number, stop: number | null = null, step: number = 1) {
    const startArray = stop ? start : 1
    const stopArray = stop ?? start
    return Array.from({ length: (stopArray - startArray) / step + 1}, (_, i) => startArray + (i * step));
}

const getDays = (month: number, year: number): number[] => {
    switch(month){
        case  1: return range(31);            
        case  2: return year %4 !== 0 ? range(28) : range(29);
        case  3: return range(31);
        case  4: return range(30);
        case  5: return range(31);
        case  6: return range(30);
        case  7: return range(31);
        case  8: return range(31);
        case  9: return range(30);
        case  10: return range(31);
        case  11: return range(30);
        case  12: return range(31);
        default: return range(30);
    }
};

export { years, months, getMonth, getDays };